var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { classNames, useEffect } from 'libs/react';
import { useState } from 'libs/react';
import { Icon } from 'components/Icon';
import { Text } from 'components/Text';
import { React } from 'libs/react';
import { ModalExport } from './modal/ModalExport';
import { MutationForm } from './form/graphql/MutationForm';
import { useAlert } from './alert/AlertStack';
import { useMemo } from 'react';
import { ExportSaleItemsMutation } from 'graphql/SaleItem/mutations/ExportSaleItemsMutation';
import { ExportSaleItemVariantsMutation } from 'graphql/SaleItemVariant/mutations/ExportSaleItemVariantsMutation';
import { ExportSaleItemOptionsMutation } from 'graphql/SaleItem/mutations/ExportSaleItemOptionsMutation';
import { ExportSaleItemOptionRelationsMutation } from 'graphql/SaleItem/mutations/ExportSaleItemOptionRelationsMutation';
import { ExportSaleItemRelationsMutation } from 'graphql/SaleItem/mutations/ExportSaleItemRelationsMutation';
import { ExportSaleItemVariantOptionsMutation } from 'graphql/SaleItemVariant/mutations/ExportSaleItemVariantOptionsMutation';
import { ExportSaleItemVariantOptionRelationsMutation } from 'graphql/SaleItemVariant/mutations/ExportSaleItemVariantOptionRelationsMutation';
import { MANUFACTURING_LIST_CONFIGURATIONS, OPTION_LIST_CONFIGURATIONS } from 'helpers/optionConfiguration';
import './ExportButton.scss';
/**
 * @component ExportButton
 * @since 1.0.0
 * @hidden
 */
export function ExportButton(props) {
    const { customClass, entityIds, exportType, statusType, filter, isEndClient, isSaleItem, isSaleAgreement, itemOnly, optionOnly, manufacturing, input, picto, label, style } = Object.assign({ style: 'normal', picto: 'download' }, props);
    const [error, setError] = useState(null);
    const [processing, setProcessing] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [optionConfiguration, setOptionConfiguration] = useState('');
    const alert = useAlert();
    /**
     * @function onClickExport
     * @since 1.0.0
     * @hidden
     */
    const onClickExport = () => {
        setOpenModal(true);
    };
    /**
     * @function onClose
     * @since 1.0.0
     * @hidden
     */
    const onClose = () => {
        setOpenModal(false);
    };
    /**
     * @function onModalSubmit
     * @since 1.0.0
     * @hidden
     */
    function onModalSubmit(formValues) {
        const { separator, dateFrom, dateTo, exportFormat, status, stage, number } = formValues;
        setProcessing(true);
        const _a = input !== null && input !== void 0 ? input : {}, { search: inputSearch, tagIds } = _a, restInput = __rest(_a, ["search", "tagIds"]);
        let additionalVariables = {};
        let query = null;
        const appendToQuery = (partial) => {
            query = Object.assign(Object.assign({}, (query !== null && query !== void 0 ? query : {})), partial);
        };
        if (filter) {
            appendToQuery({ filter: filter.fields, query: filter.default });
        }
        if (inputSearch) {
            appendToQuery({ search: inputSearch });
        }
        if (tagIds && tagIds.length > 0) {
            appendToQuery({ tagIds });
        }
        if (optionConfiguration === 'ITEM_ONLY' || itemOnly) {
            appendToQuery({ optionConfiguration: 'ITEM_ONLY' });
        }
        if (optionOnly) {
            appendToQuery({ optionConfiguration: OPTION_LIST_CONFIGURATIONS });
        }
        if (manufacturing) {
            appendToQuery({ optionConfiguration: MANUFACTURING_LIST_CONFIGURATIONS });
        }
        if (exportFormat) {
            // add exportFormat to the input
            additionalVariables = Object.assign(Object.assign({}, additionalVariables), { exportFormat: exportFormat });
        }
        if (dateFrom) {
            additionalVariables = Object.assign(Object.assign({}, additionalVariables), { dateFrom: dateFrom });
        }
        if (dateTo) {
            additionalVariables = Object.assign(Object.assign({}, additionalVariables), { dateTo: dateTo });
        }
        if (status) {
            additionalVariables = Object.assign(Object.assign({}, additionalVariables), { status: status });
        }
        if (stage) {
            additionalVariables = Object.assign(Object.assign({}, additionalVariables), { stage: stage });
        }
        if (number) {
            additionalVariables = Object.assign(Object.assign({}, additionalVariables), { number: number });
        }
        if (isEndClient) {
            appendToQuery({ isEndClient: true });
        }
        if (isEndClient === false) {
            appendToQuery({ isEndClient: false });
        }
        const isOptionsExport = optionConfiguration === 'ITEM_OPTIONS' ||
            optionConfiguration === 'VARIANT_OPTIONS' ||
            optionConfiguration === 'ITEM_RELATIONS' ||
            optionConfiguration === 'ITEM_OPTION_RELATIONS' ||
            optionConfiguration === 'VARIANT_OPTION_RELATIONS';
        if (isOptionsExport) {
            query = null;
        }
        if (exportType && exportType !== 'REPORT') {
            additionalVariables = Object.assign(Object.assign({}, additionalVariables), { exportType: exportType });
        }
        if (isOptionsExport) {
            return {
                variables: {
                    input: { separator }
                }
            };
        }
        return {
            variables: {
                input: Object.assign(Object.assign(Object.assign({ separator,
                    isEndClient }, additionalVariables), restInput), { ids: entityIds, query: query !== null && query !== void 0 ? query : undefined })
            }
        };
    }
    /**
     * @function onSuccess
     * @since 1.0.0
     * @hidden
     */
    function onSuccess(result) {
        let fileResult;
        let skipDownload = false;
        try {
            //TODO : Without this delay, sometimes file is not available yet
            setTimeout(function () {
                if (result.exportClients) {
                    fileResult = result === null || result === void 0 ? void 0 : result.exportClients;
                }
                if (result.exportContacts) {
                    fileResult = result === null || result === void 0 ? void 0 : result.exportContacts;
                }
                if (result.exportSaleAgreements) {
                    fileResult = result === null || result === void 0 ? void 0 : result.exportSaleAgreements;
                }
                if (result.exportDeals) {
                    fileResult = result === null || result === void 0 ? void 0 : result.exportDeals;
                    alert.present({ title: t('The export will be sent by email') });
                    skipDownload = true;
                }
                if (result.exportSaleItems) {
                    fileResult = result === null || result === void 0 ? void 0 : result.exportSaleItems;
                }
                if (result.exportSaleItemVariants) {
                    fileResult = result === null || result === void 0 ? void 0 : result.exportSaleItemVariants;
                    alert.present({ title: t('The export will be sent by email') });
                    skipDownload = true;
                }
                if (result.exportSaleItemOptions) {
                    fileResult = result === null || result === void 0 ? void 0 : result.exportSaleItemOptions;
                }
                if (result.exportSaleItemVariantOptions) {
                    fileResult = result === null || result === void 0 ? void 0 : result.exportSaleItemVariantOptions;
                }
                if (result.exportSaleItemManufacturing) {
                    fileResult = result === null || result === void 0 ? void 0 : result.exportSaleItemManufacturing;
                }
                if (result.exportPriceListItems) {
                    fileResult = result === null || result === void 0 ? void 0 : result.exportPriceListItems;
                }
                if (result.exportOrders) {
                    fileResult = result === null || result === void 0 ? void 0 : result.exportOrders;
                }
                if (result.exportReports) {
                    fileResult = result === null || result === void 0 ? void 0 : result.exportReports;
                    alert.present({ title: t('The export will be sent by email') });
                    skipDownload = true;
                }
                if (result.exportVouchers) {
                    fileResult = result === null || result === void 0 ? void 0 : result.exportVouchers;
                }
                if (result.exportSaleItemRelations) {
                    fileResult = result === null || result === void 0 ? void 0 : result.exportSaleItemRelations;
                }
                if (result.exportSaleItemOptionRelations) {
                    fileResult = result === null || result === void 0 ? void 0 : result.exportSaleItemOptionRelations;
                }
                if (result.exportSaleItemVariantOptionRelations) {
                    fileResult = result === null || result === void 0 ? void 0 : result.exportSaleItemVariantOptionRelations;
                }
                if (!skipDownload) {
                    download(fileResult.filepath, fileResult.filename);
                }
                setProcessing(false);
                setOpenModal(false);
            }, 1200);
        }
        catch (error) {
            setError(error);
            setProcessing(false);
            return;
        }
    }
    /**
     * @function onFailure
     * @since 1.0.0
     * @hidden
     */
    function onFailure() {
        setProcessing(false);
    }
    /**
     * @function download
     * @since 1.0.0
     * @hidden
     */
    function download(dataurl, filename) {
        const link = document.createElement('a');
        link.href = dataurl;
        link.download = filename;
        link.click();
    }
    useEffect(() => {
        if (error) {
            alert.present({ error });
        }
    }, [error]);
    /**
     * @function onChange
     * @since 1.0.0
     * @hidden
     */
    const onChange = (value) => {
        setOptionConfiguration(value);
    };
    const exportMutation = useMemo(() => {
        if (isSaleItem) {
            if (optionConfiguration === 'ITEM_ONLY') {
                return ExportSaleItemsMutation;
            }
            if (optionConfiguration === 'VARIANT') {
                return ExportSaleItemVariantsMutation;
            }
            if (optionConfiguration === 'MANUFACTURING') {
                return ExportSaleItemsMutation;
            }
            if (optionConfiguration === 'ITEM_OPTIONS') {
                return ExportSaleItemOptionsMutation;
            }
            if (optionConfiguration === 'VARIANT_OPTIONS') {
                return ExportSaleItemVariantOptionsMutation;
            }
            if (optionConfiguration === 'ITEM_RELATIONS') {
                return ExportSaleItemRelationsMutation;
            }
            if (optionConfiguration === 'ITEM_OPTION_RELATIONS') {
                return ExportSaleItemOptionRelationsMutation;
            }
            if (optionConfiguration === 'VARIANT_OPTION_RELATIONS') {
                return ExportSaleItemVariantOptionRelationsMutation;
            }
        }
        return props.exportMutation;
    }, [props.exportMutation, optionConfiguration]);
    const className = classNames('export-button', 'export-button--' + style, customClass, { 'export-button--has-error': error }, { 'export-button--is-processing': processing }, { 'export-button--has-label': label }, { 'export-button--has-picto': picto });
    return (React.createElement(React.Fragment, null,
        React.createElement("button", { className: className, onClick: onClickExport },
            picto && React.createElement(Icon, { className: "export-button-picto", value: picto }),
            label && React.createElement(Text, { className: "export-button-label", value: label })),
        openModal && (React.createElement(MutationForm, { name: "export-form", mutation: exportMutation, onProcess: onModalSubmit, onSuccess: onSuccess, onFailure: onFailure },
            React.createElement(ModalExport, { onClose: onClose, processing: processing, isSaleItem: isSaleItem, onOptionConfigurationChange: onChange, exportType: exportType, statusType: statusType })))));
}
